import React from 'react';
import { Columns, Column, Content } from '@codeparva/ui-components-library';
import { FooterOfficeAndGateHours } from '../FooterOfficeAndGateHours';
import { FooterSocialMediaIcons } from '../FooterSocialMediaIcons';
import { FooterCTAButtons } from '../FooterCTAButtons';
import { FooterTermsPrivacySiteMapAndDisclaimer } from '../FooterTermsAndPrivacyPolicy';
import { QuickLinksAndReachUsVariants } from '../helpers/quickLinkAndReachUsHelper';
import { FooterTypes } from '../footerTypes';
import { useVariant } from '../hooks/VariantContext';
import {
  CopyRightComponent,
  PoweredByLogoComponent,
} from '../helpers/CopyRightAndPoweredByHelper';
import { useThemeContext } from '../hooks/themeContext';
import { getTextColor } from '../helpers/ColorSelectorHelper';

export const FooterVariantOne = ({
  contactDetails,
  socialMediaIconsData,
  quickLinksandReachUsData,
  labelsLogoandCityStateNames,
  labelsAndLogos,
  termsPrivacySiteMapAndDisclaimer,
  facilityGateHours,
}: FooterTypes.TFooterVariant) => {
  const socialIcons = {
    socialMediaIconsData,
  };
  const currentVariant = useVariant();
  const currTheme = useThemeContext();
  return (
    <Content className="footerContainer">
      <Columns multiline>
        <Column className="footerColumnTwo is-5-desktop is-7-tablet">
          <QuickLinksAndReachUsVariants
            quickLinksandReachUsData={quickLinksandReachUsData}
            contactDetails={contactDetails}
            currentVariant={currentVariant}
          />
        </Column>
        <Column className="footerColumnOne is-4">
          <h4 className={`facilityName has-text-${getTextColor(currTheme)}`}>
            {contactDetails.facilityDetails.facilityName}
          </h4>
          {facilityGateHours && (
            <FooterOfficeAndGateHours {...facilityGateHours} />
          )}
          <FooterSocialMediaIcons {...socialIcons} />
        </Column>

        {labelsLogoandCityStateNames && (
          <FooterCTAButtons {...labelsLogoandCityStateNames} />
        )}
      </Columns>
      <Columns multiline={false}>
        <Column className="footerColumnFour">
          <Columns multiline={false} className="footerColumnsFinal">
            <CopyRightComponent
              labelsAndLogos={labelsAndLogos}
              contactDetails={contactDetails}
              currentVariant={currentVariant}
            />
            <PoweredByLogoComponent currentVariant={currentVariant} />
            <FooterTermsPrivacySiteMapAndDisclaimer
              termsPrivacySiteMapAndDisclaimer={
                termsPrivacySiteMapAndDisclaimer
              }
            />
          </Columns>
        </Column>
      </Columns>
    </Content>
  );
};

export const FooterVariantTwo = ({
  quickLinksandReachUsData,
  labelsAndLogos,
  contactDetails,
  termsPrivacySiteMapAndDisclaimer,
}: FooterTypes.TFooterVariant) => {
  const currentVariant = useVariant();
  return (
    <Content className="footerContainer">
      <Columns multiline={false} gap={0}>
        <Column className="footerColumnTwo is-4">
          <QuickLinksAndReachUsVariants
            quickLinksandReachUsData={quickLinksandReachUsData}
            contactDetails={contactDetails}
            currentVariant={currentVariant}
          />
        </Column>
        <Column className="footerColumnFour is-8">
          <Columns multiline={false} className="footerColumnsFinalVariantTwo">
            <CopyRightComponent
              labelsAndLogos={labelsAndLogos}
              contactDetails={contactDetails}
              currentVariant={currentVariant}
            />
            <FooterTermsPrivacySiteMapAndDisclaimer
              termsPrivacySiteMapAndDisclaimer={
                termsPrivacySiteMapAndDisclaimer
              }
            />
            <PoweredByLogoComponent currentVariant={currentVariant} />
          </Columns>
        </Column>
      </Columns>
    </Content>
  );
};

export const FooterVariantThree = ({
  contactDetails,
  socialMediaIconsData,
  quickLinksandReachUsData,
  labelsAndLogos,
  termsPrivacySiteMapAndDisclaimer,
}: FooterTypes.TFooterVariant) => {
  const socialIcons = {
    socialMediaIconsData,
  };
  const currentVariant = useVariant();
  const currTheme = useThemeContext();
  return (
    <Content className="footerContainer">
      <Columns>
        <Column className="footerColumnTwo">
          <QuickLinksAndReachUsVariants
            quickLinksandReachUsData={quickLinksandReachUsData}
            contactDetails={contactDetails}
            currentVariant={currentVariant}
          />
        </Column>
      </Columns>
      <hr
        className={`solid dividerFooter has-background-${getTextColor(
          currTheme
        )}`}
      />
      <Columns multiline={false} className="footerColumnsFinalVariantThree">
        <CopyRightComponent
          labelsAndLogos={labelsAndLogos}
          contactDetails={contactDetails}
          currentVariant={currentVariant}
        />
        <Column>
          <FooterSocialMediaIcons {...socialIcons} />
        </Column>
        <FooterTermsPrivacySiteMapAndDisclaimer
          termsPrivacySiteMapAndDisclaimer={termsPrivacySiteMapAndDisclaimer}
        />
        <PoweredByLogoComponent currentVariant={currentVariant} />
      </Columns>
    </Content>
  );
};

export const FooterESIMVariant = ({ contactDetails, labelsAndLogos }: any) => {
  const currentVariant = useVariant();
  return (
    <Content className="footerContainer eSimContainer">
      <CopyRightComponent
        labelsAndLogos={labelsAndLogos}
        contactDetails={contactDetails}
        currentVariant={currentVariant}
      />
      <PoweredByLogoComponent currentVariant={currentVariant} />
    </Content>
  );
};
